const initialState = {
    data: {},
    loading: false,
    submitting: false,
}

const maintainReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MAINTAIN_DATA':
            return {
                ...state,
                ...action.payload
            }
        case 'MAINTAIN_DATA_INIT':
            return initialState
        default:
            return {...state};
    }
}

export default maintainReducer
